(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chicchok-series-page-native"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pageCache = new Map();
    const pageRequests = new Map();
    const groupStates = new WeakMap();
    const initializedGalleries = new WeakSet();
    const sectionObservers = new WeakMap();
    const prefetchSchedulers = new WeakMap();
    const transitionDuration = 110;
    const requestTimeout = 15000;
    const prefetchTimeout = 20000;
    const prefetchMaxAttempts = 2;
    const sessionCachePrefix = 'chicchok-series-pages-v3';
    const sessionCacheTtl = 30 * 60 * 1000;

    const wait = duration => new Promise(resolve => window.setTimeout(resolve, duration));
    const nextFrame = () => new Promise(resolve => window.requestAnimationFrame(() => window.requestAnimationFrame(resolve)));
    const restoreScroll = position => {
      const previousScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(position.left, position.top);
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
    };

    const activateGalleryImage = (mediaItem, eager = false) => {
      const image = mediaItem?.querySelector('img');

      if (!image) {
        return;
      }

      if (eager) {
        image.loading = 'eager';
        image.fetchPriority = 'high';
      }

      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        delete image.dataset.srcset;
      }

      if (image.dataset.src) {
        image.src = image.dataset.src;
        delete image.dataset.src;
      }
    };

    const updateGallery = (gallery, nextIndex, eager = false) => {
      const mediaItems = Array.from(gallery.querySelectorAll('[data-native-series-media]'));

      if (mediaItems.length < 2) {
        return;
      }

      const index = Math.max(0, Math.min(nextIndex, mediaItems.length - 1));
      const previousButton = gallery.querySelector('[data-native-series-media-prev]');
      const nextButton = gallery.querySelector('[data-native-series-media-next]');
      const status = gallery.querySelector('[data-native-series-media-status]');
      const controlIndex = gallery.dataset.nativeSeriesHoverOrigin === undefined
        ? index
        : Number(gallery.dataset.nativeSeriesHoverOrigin || 0);

      gallery.dataset.nativeSeriesMediaIndex = String(index);
      activateGalleryImage(mediaItems[index], eager);

      mediaItems.forEach((mediaItem, mediaIndex) => {
        const isActive = mediaIndex === index;
        mediaItem.classList.toggle('is-active', isActive);
        mediaItem.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (previousButton) {
        previousButton.disabled = controlIndex === 0;
        previousButton.setAttribute('aria-disabled', controlIndex === 0 ? 'true' : 'false');
      }

      if (nextButton) {
        nextButton.disabled = controlIndex === mediaItems.length - 1;
        nextButton.setAttribute('aria-disabled', controlIndex === mediaItems.length - 1 ? 'true' : 'false');
      }

      if (previousButton && document.activeElement === previousButton && previousButton.disabled && nextButton && !nextButton.disabled) {
        nextButton.focus({ preventScroll: true });
      }

      if (nextButton && document.activeElement === nextButton && nextButton.disabled && previousButton && !previousButton.disabled) {
        previousButton.focus({ preventScroll: true });
      }

      if (status) {
        status.textContent = `${index + 1} / ${mediaItems.length}`;
      }
    };

    const moveGallery = (gallery, direction) => {
      const currentIndex = gallery.dataset.nativeSeriesHoverOrigin === undefined
        ? Number(gallery.dataset.nativeSeriesMediaIndex || 0)
        : Number(gallery.dataset.nativeSeriesHoverOrigin || 0);

      delete gallery.dataset.nativeSeriesHoverOrigin;
      gallery.classList.remove('is-hover-preview');
      updateGallery(gallery, currentIndex + direction, true);
    };

    const initGallery = gallery => {
      if (initializedGalleries.has(gallery)) {
        return;
      }

      initializedGalleries.add(gallery);
      gallery.dataset.nativeSeriesMediaIndex = '0';
      updateGallery(gallery, 0);

      const supportsHoverPreview = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (supportsHoverPreview) {
        gallery.addEventListener('mouseenter', () => {
          const mediaItems = Array.from(gallery.querySelectorAll('[data-native-series-media]'));

          if (mediaItems.length < 2 || gallery.dataset.nativeSeriesHoverOrigin !== undefined) {
            return;
          }

          const currentIndex = Number(gallery.dataset.nativeSeriesMediaIndex || 0);
          const previewIndex = currentIndex < mediaItems.length - 1 ? currentIndex + 1 : currentIndex - 1;
          gallery.dataset.nativeSeriesHoverOrigin = String(currentIndex);
          gallery.classList.add('is-hover-preview');
          updateGallery(gallery, previewIndex, true);
        });

        gallery.addEventListener('mouseleave', () => {
          if (gallery.dataset.nativeSeriesHoverOrigin === undefined) {
            return;
          }

          const originIndex = Number(gallery.dataset.nativeSeriesHoverOrigin || 0);

          delete gallery.dataset.nativeSeriesHoverOrigin;
          gallery.classList.remove('is-hover-preview');
          updateGallery(gallery, originIndex);
        });
      }

      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveGallery(gallery, -1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveGallery(gallery, 1);
        }
      });

      let pointerStart = null;
      let touchStart = null;

      const handleSwipe = (deltaX, deltaY) => {
        if (Math.abs(deltaX) < 38 || Math.abs(deltaX) <= Math.abs(deltaY)) {
          return;
        }

        gallery.dataset.nativeSeriesSuppressClick = 'true';
        moveGallery(gallery, deltaX < 0 ? 1 : -1);

        window.setTimeout(() => {
          delete gallery.dataset.nativeSeriesSuppressClick;
        }, 0);
      };

      gallery.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || event.button !== 0 || event.target.closest('[data-native-series-media-prev], [data-native-series-media-next]')) {
          return;
        }

        pointerStart = {
          x: event.clientX,
          y: event.clientY,
          id: event.pointerId
        };
      });

      gallery.addEventListener('pointermove', event => {
        if (event.pointerType === 'touch' || !pointerStart || pointerStart.id !== event.pointerId) {
          return;
        }

        const deltaX = event.clientX - pointerStart.x;
        const deltaY = event.clientY - pointerStart.y;

        if (
          Math.abs(deltaX) >= 38
          && Math.abs(deltaX) > Math.abs(deltaY)
          && gallery.setPointerCapture
          && (!gallery.hasPointerCapture || !gallery.hasPointerCapture(event.pointerId))
        ) {
          gallery.setPointerCapture(event.pointerId);
        }
      });

      gallery.addEventListener('pointerup', event => {
        if (event.pointerType === 'touch' || !pointerStart || pointerStart.id !== event.pointerId) {
          return;
        }

        const deltaX = event.clientX - pointerStart.x;
        const deltaY = event.clientY - pointerStart.y;

        if (gallery.hasPointerCapture && gallery.hasPointerCapture(event.pointerId)) {
          gallery.releasePointerCapture(event.pointerId);
        }

        pointerStart = null;
        handleSwipe(deltaX, deltaY);
      });

      gallery.addEventListener('pointercancel', () => {
        pointerStart = null;
      });

      gallery.addEventListener('touchstart', event => {
        const touch = event.touches[0];

        if (!touch || event.target.closest('[data-native-series-media-prev], [data-native-series-media-next]')) {
          return;
        }

        touchStart = {
          x: touch.clientX,
          y: touch.clientY
        };
      }, { passive: true });

      gallery.addEventListener('touchmove', event => {
        const touch = event.touches[0];

        if (!touchStart || !touch) {
          return;
        }

        const deltaX = touch.clientX - touchStart.x;
        const deltaY = touch.clientY - touchStart.y;

        if (Math.abs(deltaX) < 38 || Math.abs(deltaX) <= Math.abs(deltaY)) {
          return;
        }

        touchStart = null;
        handleSwipe(deltaX, deltaY);
      }, { passive: true });

      gallery.addEventListener('touchend', event => {
        const touch = event.changedTouches[0];

        if (!touchStart || !touch) {
          return;
        }

        const deltaX = touch.clientX - touchStart.x;
        const deltaY = touch.clientY - touchStart.y;
        touchStart = null;
        handleSwipe(deltaX, deltaY);
      }, { passive: true });

      gallery.addEventListener('touchcancel', () => {
        touchStart = null;
      }, { passive: true });

      const mediaLink = gallery.querySelector('.chicchok-series-page-native__product-media');

      if (mediaLink) {
        mediaLink.addEventListener('click', event => {
          if (gallery.dataset.nativeSeriesSuppressClick === 'true') {
            event.preventDefault();
          }
        });
      }
    };

    const initReveal = section => {
      const revealItems = Array.from(section.querySelectorAll('[data-native-series-reveal]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const existingObserver = sectionObservers.get(section);

      if (existingObserver) {
        existingObserver.disconnect();
        sectionObservers.delete(section);
      }

      section.classList.add('is-native-series-ready');

      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach(item => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        threshold: .08,
        rootMargin: '0px 0px -6% 0px'
      });

      sectionObservers.set(section, observer);
      revealItems.forEach(item => observer.observe(item));
    };

    const getGroupState = group => {
      let state = groupStates.get(group);

      if (!state) {
        state = {
          controller: null,
          requestId: 0
        };
        groupStates.set(group, state);
      }

      return state;
    };

    const getCacheKey = (group, page) => `${group.dataset.collectionUrl}|${page}`;

    const getSessionCacheKey = (group, page) => {
      const section = group.closest('[data-chicchok-series-native]');
      const themeId = section?.dataset.themeId || 'published';
      return `${sessionCachePrefix}:${themeId}:${getCacheKey(group, page)}`;
    };

    const storePagePayload = (group, page, payload) => {
      const cacheKey = getCacheKey(group, page);
      pageCache.set(cacheKey, payload);

      try {
        window.sessionStorage.setItem(getSessionCacheKey(group, page), JSON.stringify({
          cachedAt: Date.now(),
          payload
        }));
      } catch (_error) {
        // Memory caching still works when storage is unavailable or full.
      }
    };

    const getPagePayload = (group, page) => {
      const cacheKey = getCacheKey(group, page);

      if (pageCache.has(cacheKey)) {
        return pageCache.get(cacheKey);
      }

      try {
        const sessionCacheKey = getSessionCacheKey(group, page);
        const cached = JSON.parse(window.sessionStorage.getItem(sessionCacheKey) || 'null');

        if (!cached || Date.now() - Number(cached.cachedAt || 0) > sessionCacheTtl) {
          window.sessionStorage.removeItem(sessionCacheKey);
          return null;
        }

        if (!cached.payload || Number(cached.payload.currentPage) !== Number(page) || typeof cached.payload.html !== 'string') {
          window.sessionStorage.removeItem(sessionCacheKey);
          return null;
        }

        pageCache.set(cacheKey, cached.payload);
        return cached.payload;
      } catch (_error) {
        return null;
      }
    };

    const clearTransitionClasses = content => {
      if (!content) {
        return;
      }

      content.classList.remove(
        'is-page-leaving-next',
        'is-page-leaving-previous',
        'is-page-entering-next',
        'is-page-entering-previous'
      );
    };

    const initDynamicContent = content => {
      content.querySelectorAll('[data-native-series-gallery]').forEach(initGallery);
      content.querySelectorAll('[data-native-series-reveal]').forEach(item => {
        item.classList.add('is-visible');
        item.removeAttribute('data-native-series-reveal');
      });
    };

    const setPaginationStatus = (group, text, isError = false) => {
      const status = group.querySelector('[data-native-series-pagination-status]');

      if (!status) {
        return;
      }

      status.textContent = text;
      status.classList.toggle('is-error', isError);
    };

    const buildSectionRequestUrl = (group, page) => {
      const requestUrl = new URL(group.dataset.collectionUrl, window.location.origin);
      const section = group.closest('[data-chicchok-series-native]');
      const urlPreviewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      const previewThemeId = urlPreviewThemeId || (section?.dataset.themeRole === 'unpublished' ? section.dataset.themeId : '');

      requestUrl.searchParams.set('section_id', 'chicchok-series-product-group');
      requestUrl.searchParams.set('page', String(page));

      if (previewThemeId) {
        requestUrl.searchParams.set('preview_theme_id', previewThemeId);
      }

      return requestUrl;
    };

    const fetchWithTransientRetry = async (url, options, maxRetries = 1) => {
      for (let attempt = 0; attempt <= maxRetries; attempt += 1) {
        try {
          const response = await fetch(url, options);
          const isTransient = response.status === 429 || response.status >= 500;

          if (response.ok || !isTransient || attempt === maxRetries) {
            return response;
          }
        } catch (error) {
          if (error.name === 'AbortError' || attempt === maxRetries) {
            throw error;
          }
        }

        await wait(400 * (attempt + 1));
      }

      throw new Error('Series group request retry failed');
    };

    const parseGroupPayload = (html, group) => {
      if (!html.trim()) {
        throw new Error('Empty series group response');
      }

      const template = document.createElement('template');
      template.innerHTML = html;
      const fragment = template.content.querySelector('[data-chicchok-series-group-fragment]');
      const content = fragment && fragment.querySelector('[data-native-series-group-content]');

      if (!fragment || !content || fragment.dataset.seriesGroup !== group.dataset.seriesGroup) {
        throw new Error('Invalid series group response');
      }

      return {
        currentPage: Number(fragment.dataset.currentPage || 1),
        html: content.innerHTML
      };
    };

    const fetchPrefetchedPayload = (group, page) => {
      const cacheKey = getCacheKey(group, page);

      const cachedPayload = getPagePayload(group, page);

      if (cachedPayload) {
        return Promise.resolve(cachedPayload);
      }

      if (pageRequests.has(cacheKey)) {
        return pageRequests.get(cacheKey).promise;
      }

      const controller = new AbortController();
      let timeoutId = null;
      const request = {
        controller,
        promise: null
      };

      request.promise = (async () => {
        timeoutId = window.setTimeout(() => controller.abort(), prefetchTimeout);

        try {
          const response = await fetchWithTransientRetry(buildSectionRequestUrl(group, page), {
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            priority: 'low',
            signal: controller.signal
          });

          if (!response.ok) {
            return null;
          }

          const payload = parseGroupPayload(await response.text(), group);
          storePagePayload(group, page, payload);
          const prefetchedPages = new Set((group.dataset.nativeSeriesPrefetchedPages || '').split(',').filter(Boolean));
          prefetchedPages.add(String(page));
          group.dataset.nativeSeriesPrefetchedPages = Array.from(prefetchedPages).sort((left, right) => Number(left) - Number(right)).join(',');

          if (!group.dataset.nativeSeriesPrefetchedPage) {
            group.dataset.nativeSeriesPrefetchedPage = String(page);
          }

          return payload;
        } catch (_error) {
          return null;
        } finally {
          window.clearTimeout(timeoutId);
          pageRequests.delete(cacheKey);
        }
      })();

      pageRequests.set(cacheKey, request);
      return request.promise;
    };

    const updatePrefetchState = scheduler => {
      const remaining = scheduler.queue.length + scheduler.active;
      scheduler.section.dataset.nativeSeriesPrefetchCompleted = String(scheduler.completed);

      if (!scheduler.started) {
        scheduler.section.dataset.nativeSeriesPrefetchState = 'waiting';
      } else if (remaining > 0) {
        scheduler.section.dataset.nativeSeriesPrefetchState = scheduler.userRequests > 0 ? 'paused' : 'loading';
      } else {
        scheduler.section.dataset.nativeSeriesPrefetchState = scheduler.failed > 0 ? 'partial' : 'complete';
      }
    };

    const pumpPrefetchQueue = scheduler => {
      if (scheduler.stopped || !scheduler.started || scheduler.userRequests > 0) {
        updatePrefetchState(scheduler);
        return;
      }

      while (scheduler.active < scheduler.concurrency && scheduler.queue.length > 0) {
        const task = scheduler.queue.shift();
        const cacheKey = getCacheKey(task.group, task.page);

        if (getPagePayload(task.group, task.page) || pageRequests.has(cacheKey)) {
          scheduler.completed += 1;
          continue;
        }

        scheduler.active += 1;
        scheduler.activeTasks.set(cacheKey, task);

        fetchPrefetchedPayload(task.group, task.page)
          .then(payload => {
            if (payload) {
              scheduler.completed += 1;
              return;
            }

            if (task.preemptedByUser && !scheduler.stopped) {
              delete task.preemptedByUser;
              scheduler.queue.unshift(task);
              return;
            }

            if (task.attempt < prefetchMaxAttempts && !scheduler.stopped) {
              scheduler.queue.push({ ...task, attempt: task.attempt + 1 });
            } else {
              scheduler.failed += 1;
            }
          })
          .finally(() => {
            scheduler.activeTasks.delete(cacheKey);
            scheduler.active -= 1;
            updatePrefetchState(scheduler);
            pumpPrefetchQueue(scheduler);
          });
      }

      updatePrefetchState(scheduler);
    };

    const prioritizeUserRequest = (section, group, page) => {
      const scheduler = prefetchSchedulers.get(section);

      if (!scheduler) {
        return () => {};
      }

      const taskIndex = scheduler.queue.findIndex(task => task.group === group && task.page === page);
      let prioritizedTask = null;

      if (taskIndex >= 0) {
        prioritizedTask = scheduler.queue.splice(taskIndex, 1)[0];
      }

      scheduler.userRequests += 1;
      scheduler.activeTasks.forEach((task, cacheKey) => {
        if (cacheKey === getCacheKey(group, page)) {
          return;
        }

        const request = pageRequests.get(cacheKey);

        if (request) {
          task.preemptedByUser = true;
          request.controller.abort();
        }
      });
      updatePrefetchState(scheduler);

      return () => {
        if (prioritizedTask) {
          if (getPagePayload(group, page)) {
            scheduler.completed += 1;
          } else if (!scheduler.stopped) {
            scheduler.queue.unshift(prioritizedTask);
          }
        }

        scheduler.userRequests = Math.max(0, scheduler.userRequests - 1);
        updatePrefetchState(scheduler);
        pumpPrefetchQueue(scheduler);
      };
    };

    const initPagePrefetch = section => {
      if (window.__chicchokDisableSeriesPrefetch === true) {
        section.dataset.nativeSeriesPrefetchState = 'disabled';
        return;
      }

      const groups = Array.from(section.querySelectorAll('[data-native-series-group]'));
      const maxPages = groups.reduce((maximum, group) => Math.max(maximum, Number(group.dataset.totalPages || 1)), 1);
      const queue = [];

      for (let page = 2; page <= maxPages; page += 1) {
        groups.forEach(group => {
          if (page <= Number(group.dataset.totalPages || 1)) {
            queue.push({ group, page, attempt: 1 });
          }
        });
      }

      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const effectiveType = connection?.effectiveType || '';
      const saveData = connection?.saveData === true;
      const isVerySlow = saveData || /(^|-)2g$/.test(effectiveType);
      const isSlow = isVerySlow || /(^|-)3g$/.test(effectiveType);
      const scheduler = {
        section,
        queue,
        active: 0,
        activeTasks: new Map(),
        completed: 0,
        failed: 0,
        userRequests: 0,
        concurrency: 1,
        startDelay: isVerySlow ? 2500 : (isSlow ? 1400 : 800),
        started: false,
        stopped: false,
        startTimer: null,
        idleCallbackId: null,
        loadHandler: null
      };

      prefetchSchedulers.set(section, scheduler);
      section.dataset.nativeSeriesPrefetchTotal = String(queue.length);
      section.dataset.nativeSeriesPrefetchConcurrency = String(scheduler.concurrency);
      section.dataset.nativeSeriesPrefetchNetwork = saveData ? 'save-data' : (effectiveType || 'unknown');
      updatePrefetchState(scheduler);

      const start = () => {
        if (scheduler.stopped || scheduler.started) {
          return;
        }

        const begin = () => {
          scheduler.idleCallbackId = null;
          scheduler.startTimer = null;

          if (scheduler.stopped) {
            return;
          }

          scheduler.startTimer = null;
          scheduler.started = true;
          updatePrefetchState(scheduler);
          pumpPrefetchQueue(scheduler);
        };

        if ('requestIdleCallback' in window) {
          scheduler.idleCallbackId = window.requestIdleCallback(begin, { timeout: scheduler.startDelay });
        } else {
          scheduler.startTimer = window.setTimeout(begin, scheduler.startDelay);
        }
      };

      if (document.readyState === 'complete') {
        start();
      } else {
        scheduler.loadHandler = start;
        window.addEventListener('load', scheduler.loadHandler, { once: true });
      }
    };

    const replaceGroupContent = async (group, payload, direction, state, requestId, focusTarget, scrollPosition) => {
      const content = group.querySelector('[data-native-series-group-content]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const directionName = direction > 0 ? 'next' : 'previous';
      let shouldRestoreFocus = false;
      let shouldPreserveScroll = false;

      if (!content) {
        throw new Error('Series group content is missing');
      }

      clearTransitionClasses(content);

      if (!reducedMotion) {
        content.classList.add(`is-page-leaving-${directionName}`);
        await wait(transitionDuration);

        if (state.requestId !== requestId) {
          return false;
        }
      }

      shouldRestoreFocus = focusTarget && document.activeElement === focusTarget;
      shouldPreserveScroll = Math.abs(window.scrollX - scrollPosition.left) <= 4 && Math.abs(window.scrollY - scrollPosition.top) <= 4;
      content.innerHTML = payload.html;
      group.dataset.currentPage = String(payload.currentPage);
      initDynamicContent(content);

      if (shouldPreserveScroll) {
        restoreScroll(scrollPosition);
      }

      if (!reducedMotion) {
        clearTransitionClasses(content);
        content.classList.add(`is-page-entering-${directionName}`);
        void content.offsetWidth;
        group.setAttribute('aria-busy', 'false');
        await nextFrame();

        if (state.requestId !== requestId) {
          return false;
        }

        content.classList.remove(`is-page-entering-${directionName}`);
        await wait(transitionDuration);
      }

      if (state.requestId !== requestId) {
        return false;
      }

      const currentPageItem = content.querySelector('.chicchok-series-page-native__pagination-item.is-current');

      if (shouldRestoreFocus && currentPageItem) {
        currentPageItem.focus({ preventScroll: true });
      }

      if (shouldPreserveScroll) {
        restoreScroll(scrollPosition);
      }

      return true;
    };

    const loadGroupPage = async (section, group, targetPage, focusTarget) => {
      const currentPage = Number(group.dataset.currentPage || 1);

      if (!Number.isInteger(targetPage) || targetPage < 1 || targetPage === currentPage) {
        return;
      }

      const state = getGroupState(group);
      const requestId = state.requestId + 1;
      const cacheKey = getCacheKey(group, targetPage);
      const collectionTitle = group.querySelector('.chicchok-series-page-native__group-title a')?.textContent.trim() || '';
      const loadingLabel = section.dataset.paginationLoadingLabel || '';
      const errorLabel = section.dataset.paginationErrorLabel || '';
      const scrollPosition = {
        left: window.scrollX,
        top: window.scrollY
      };
      let didTimeout = false;
      let timeoutId = null;
      let resumePrefetch = null;

      state.requestId = requestId;

      if (state.controller) {
        state.controller.abort();
      }

      state.controller = null;
      clearTransitionClasses(group.querySelector('[data-native-series-group-content]'));
      group.setAttribute('aria-busy', 'true');
      setPaginationStatus(group, loadingLabel);

      try {
        let payload = getPagePayload(group, targetPage);

        if (!payload) {
          resumePrefetch = prioritizeUserRequest(section, group, targetPage);
        }

        if (!payload && pageRequests.has(cacheKey)) {
          payload = await pageRequests.get(cacheKey).promise;
        }

        if (!payload) {
          const controller = new AbortController();
          state.controller = controller;
          timeoutId = window.setTimeout(() => {
            didTimeout = true;
            controller.abort();
          }, requestTimeout);

          let response;

          try {
            response = await fetchWithTransientRetry(buildSectionRequestUrl(group, targetPage), {
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              },
              priority: 'high',
              signal: controller.signal
            });
          } finally {
            window.clearTimeout(timeoutId);
            timeoutId = null;
          }

          if (!response.ok) {
            throw new Error(`Series group request failed with ${response.status}`);
          }

          payload = parseGroupPayload(await response.text(), group);
          storePagePayload(group, targetPage, payload);
        }

        if (state.requestId !== requestId) {
          return;
        }

        const didReplace = await replaceGroupContent(group, payload, targetPage > currentPage ? 1 : -1, state, requestId, focusTarget, scrollPosition);

        if (!didReplace || state.requestId !== requestId) {
          return;
        }

        const loadedLabel = (section.dataset.paginationLoadedLabel || '')
          .replace('__COLLECTION__', collectionTitle)
          .replace('__PAGE__', String(payload.currentPage));

        setPaginationStatus(group, loadedLabel);
      } catch (error) {
        if ((error.name === 'AbortError' && !didTimeout) || state.requestId !== requestId) {
          return;
        }

        clearTransitionClasses(group.querySelector('[data-native-series-group-content]'));
        setPaginationStatus(group, errorLabel, true);
      } finally {
        if (timeoutId) {
          window.clearTimeout(timeoutId);
        }

        if (state.requestId === requestId) {
          state.controller = null;
          group.setAttribute('aria-busy', 'false');
        }

        if (resumePrefetch) {
          resumePrefetch();
        }
      }
    };

    const initSection = section => {
      if (section.dataset.nativeSeriesSectionReady === 'true') {
        return;
      }

      section.dataset.nativeSeriesSectionReady = 'true';
      section.querySelectorAll('[data-native-series-gallery]').forEach(initGallery);
      section.querySelectorAll('[data-native-series-group]').forEach(group => {
        const content = group.querySelector('[data-native-series-group-content]');

        if (content) {
          storePagePayload(group, 1, {
            currentPage: 1,
            html: content.innerHTML
          });
        }
      });

      section.addEventListener('click', event => {
        const pageLink = event.target.closest('[data-native-series-page]');

        if (pageLink) {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
          }

          const group = pageLink.closest('[data-native-series-group]');
          const targetPage = Number(pageLink.dataset.nativeSeriesPage);

          if (group) {
            event.preventDefault();
            event.stopPropagation();
            loadGroupPage(section, group, targetPage, pageLink);
          }

          return;
        }

        const previousButton = event.target.closest('[data-native-series-media-prev]');
        const nextButton = event.target.closest('[data-native-series-media-next]');
        const button = previousButton || nextButton;

        if (!button) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const gallery = button.closest('[data-native-series-gallery]');

        if (gallery) {
          moveGallery(gallery, previousButton ? -1 : 1);
        }
      });

      requestAnimationFrame(() => {
        initReveal(section);
        initPagePrefetch(section);
      });
    };

    const cleanupSection = section => {
      const observer = sectionObservers.get(section);

      if (observer) {
        observer.disconnect();
        sectionObservers.delete(section);
      }

      const prefetchScheduler = prefetchSchedulers.get(section);

      if (prefetchScheduler) {
        prefetchScheduler.stopped = true;

        if (prefetchScheduler.startTimer) {
          window.clearTimeout(prefetchScheduler.startTimer);
        }

        if (prefetchScheduler.idleCallbackId && 'cancelIdleCallback' in window) {
          window.cancelIdleCallback(prefetchScheduler.idleCallbackId);
        }

        if (prefetchScheduler.loadHandler) {
          window.removeEventListener('load', prefetchScheduler.loadHandler);
        }

        prefetchSchedulers.delete(section);
      }

      section.querySelectorAll('[data-native-series-group]').forEach(group => {
        const state = groupStates.get(group);

        if (state) {
          state.requestId += 1;

          if (state.controller) {
            state.controller.abort();
          }

          groupStates.delete(group);
        }
      });

      pageCache.clear();
      pageRequests.forEach(request => request.controller.abort());
      pageRequests.clear();
      delete section.dataset.nativeSeriesSectionReady;
    };

    const initSections = root => {
      root.querySelectorAll('[data-chicchok-series-native]').forEach(initSection);
    };

    const init = () => initSections(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', event => initSections(event.target));
    document.addEventListener('shopify:section:unload', event => {
      const section = event.target.matches?.('[data-chicchok-series-native]')
        ? event.target
        : event.target.querySelector('[data-chicchok-series-native]');

      if (section) {
        cleanupSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["net-guide-article"] && !Shopify.designMode) return;
  try {
    
  function initializeGuideArticles(root) {
    root.querySelectorAll('.ng-article').forEach(function(section) {
      var toc = section.querySelector('.ng-article-toc');
      if (!toc || toc.dataset.ready) return;
      var headings = section.querySelectorAll('.ng-article-body h2');
      if (headings.length < 2) return;
      var list = toc.querySelector('ol');
      headings.forEach(function(heading, index) {
        if (!heading.id) heading.id = section.id + '-part-' + (index + 1);
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
      toc.dataset.ready = 'true';
      toc.hidden = false;
    });
  }
  initializeGuideArticles(document);
  document.addEventListener('shopify:section:load', function(event) { initializeGuideArticles(event.target); });

  } catch(e) { console.error(e); }
})();
})();
